"use client";

import { MapPin, Phone, Mail, Clock, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function LocationMap() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="192379" id="contactdetails" className="bg-background py-16 md:py-24 overflow-hidden flex flex-col items-center justify-center min-h-screen">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 justify-items-center">
          <div ref={leftRef} className={`flex flex-col transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} w-full max-w-4xl`}>
            <div className="mb-8 text-center">
              <h2 className="text-3xl md:text-4xl font-bold font-serif text-foreground mb-4">
                Στοιχεία Επικοινωνίας & Τοποθεσία
              </h2>
              <p className="text-muted-foreground font-sans text-lg max-w-2xl mx-auto">
                Με έδρα τις Αχαρνές, Ο Συνήγορος του ένστολου παρέχει εξειδικευμένες συμβουλευτικές υπηρεσίες υψηλού επιπέδου σε όλη την επικράτεια.
              </p>
            </div>

            <Card className="rounded-none border-border shadow-lg bg-card py-16 md:py-24 gap-12">
              <CardHeader className="border-b border-border pb-12 px-12 md:px-20">
                <CardTitle className="font-serif text-2xl text-foreground">
                  Κεντρικά Γραφεία
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-12 px-12 md:px-20 grid gap-12">
                <div className="flex items-start gap-6">
                  <MapPin className="size-7 text-primary shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-foreground font-sans text-lg">Διεύθυνση</h3>
                    <p className="text-muted-foreground font-sans mt-1.5 text-2xl">Λεωφ. Αθηνών 29 , Αχαρνές, 136 71<br /></p>
                  </div>
                </div>
                <Separator className="bg-border" />
                <div className="flex items-start gap-6">
                  <Phone className="size-7 text-primary shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-foreground font-sans text-lg">Τηλέφωνο</h3>
                    <p className="text-foreground font-sans mt-2 text-2xl md:text-3xl font-bold">210 2445186 / 698 7318178</p>
                  </div>
                </div>
                <Separator className="bg-border" />
                <div className="flex items-start gap-6">
                  <Mail className="size-7 text-primary shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-foreground font-sans text-lg">Email</h3>
                    <p className="text-muted-foreground font-sans mt-1.5 md:text-3xl">a6987318178@gmail.com</p>
                  </div>
                </div>
                <Separator className="bg-border" />
                <div className="flex items-start gap-6">
                  <Clock className="size-7 text-primary shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-foreground font-sans text-lg">Ωράριο</h3>
                    <p className="text-muted-foreground font-sans mt-1.5 text-2xl md:text-3xl">Δευτέρα - Παρασκευή: 09:00 - 21:00<br />Επείγουσα Επικοινωνία: 24/7</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <div className="mt-8 flex justify-center">
              <Button asChild size="lg" className="rounded-none font-sans font-semibold bg-primary text-primary-foreground hover:bg-primary/90">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}